var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_12519_21243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.32122 0V3.76148C6.82286 3.58871 6.29118 3.49129 5.74075 3.48238C4.37778 3.46008 3.08544 3.97629 2.10454 4.93527C1.1243 5.89359 0.579656 7.17187 0.570906 8.53461C0.562117 9.90242 1.10579 11.2142 2.07091 12.1744V16.5184H7.32126V20H20.5708V0H7.32122ZM15.9949 13.7428L15.7479 11.3157L14.7054 11.0591L14.9435 10.3548C15.2175 9.5443 15.4295 8.71488 15.5735 7.88969C15.8954 6.0452 17.4898 4.68441 19.3647 4.65406C19.3761 4.65387 19.3875 4.65418 19.399 4.6541V7.09367L16.4235 10.0691L17.2522 10.8977L19.3989 8.75094V15.3464H17.7652V13.7428H15.9949ZM8.49309 1.17188H12.5315L10.05 3.65332L10.8786 4.48195L14.1887 1.17188H16.0471L10.4253 6.79367C10.0497 5.78281 9.36489 4.93234 8.49313 4.34637L8.49309 1.17188ZM3.04762 11.4854C2.21114 10.7366 1.73552 9.66387 1.74274 8.54211C1.74946 7.49457 2.16891 6.51121 2.9238 5.7732C3.6793 5.03457 4.6727 4.63715 5.7218 4.6541C7.59669 4.68441 9.19106 6.0452 9.51294 7.88969C9.65692 8.71484 9.86887 9.54422 10.1429 10.3548L10.3811 11.0591L9.33856 11.3157L9.09149 13.7429H7.32122V15.3464H3.24278V11.66L3.04762 11.4854ZM8.49309 18.8281V14.9147H10.1501L10.4207 12.2562L11.8997 11.8921L11.2531 9.97953C11.0465 9.36863 10.8787 8.74672 10.751 8.12516L17.7043 1.17188H19.3989V3.48246C19.3812 3.48258 19.3634 3.48207 19.3457 3.48238C16.9094 3.5218 14.8375 5.29063 14.4191 7.68824C14.2853 8.45465 14.0882 9.22555 13.8333 9.97953L13.1867 11.8921L14.6657 12.2562L14.9363 14.9147H16.5933V16.5184H19.3989V18.8281H8.49309Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.570801)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror);
export default __webpack_public_path__ + "static/media/mirror.0930d8e654f05103f18cdc9be011b860.svg";
export { ForwardRef as ReactComponent };